export function getType(variable) {
    return Object.prototype.toString.call(variable).slice(8, -1).toLowerCase();
}
export default function isEqual(a, b) {
    var aType = getType(a);
    var bType = getType(b);
    // If the two objects are not the same type, return false
    if (aType !== bType) return false;
    if (aType === "object" || aType === "array") {
        var bKeys = Object.keys(b);
        var aKeys = Object.keys(a);
        // muse have the same number of keys
        if (aKeys.length !== bKeys.length) return false;
        // Muse have the same keys and values
        for(var i = 0; i < bKeys.length; i += 1){
            var aValue = a[bKeys[i]];
            var bValue = b[bKeys[i]];
            if (!isEqual(aValue, bValue)) {
                return false;
            }
        }
    } else if (aType === "function" && a.toString() !== b.toString()) {
        return false;
    } else if (a !== b) {
        return false;
    }
    return true;
}

//# sourceMappingURL=isEqual.js.map